import { useEffect, useState } from "react";
import SelectComponent from "../../common/Select";
import {
  useTourList,
  useTourListActions,
} from "../../Providers/TourListProvider";

const Filter = ({ setSearchValue }) => {
  const { dispatch } = useTourListActions();
  const stateOptions = [
    { value: 2, label: "همه تورها" },
    { value: 0, label: "تور های فعال" },
    { value: 1, label: "تور‌های غیر فعال" },
  ];
  const options = [
    { value: 3, label: "همه" },
    { value: 1, label: "طبیعت‌گردی" },
    { value: 0, label: "هوایی" },
    { value: 2, label: "زمینی" },
  ];

  const sortOptions = [
    { value: "highest", label: "جدیدترین" },
    { value: "lowest", label: "قدیمی‌ترین" },
  ];
  const [state, setState] = useState({ value: 0, label: "تور های فعال" });
  const [value, setValue] = useState({ value: 3, label: "همه" });
  const [sort, setSort] = useState("");

  const stateHandler = (selectedOption) => {
    dispatch({ type: "STATE_TOUR", selectedOption });
    dispatch({ type: "FILTER_TOUR", selectedOption: value });
    dispatch({ type: "SORT_TOUR", selectedOption: sort });
    setSearchValue("");
    setState(selectedOption);
  };
  const changeHandler = (selectedOption) => {
    dispatch({ type: "FILTER_TOUR", selectedOption });
    dispatch({ type: "SORT_TOUR", selectedOption: sort });
    setSearchValue("");
    setValue(selectedOption);
  };

  const sortHandler = (selectedOption) => {
    dispatch({ type: "SORT_TOUR", selectedOption });
    setSearchValue("");
    setSort(selectedOption);
  };

  return (
    <div className="flex flex-wrap justify-between gap-2">
      <SelectComponent
        title="وضعیت تور"
        placeholder="وضعیت تور"
        value={state}
        onChange={stateHandler}
        options={stateOptions}
      />
      <SelectComponent
        title="نوع تور"
        placeholder="نوع تور"
        value={value}
        onChange={changeHandler}
        options={options}
      />
      <SelectComponent
        title="بر اساس تاریخ ثبت"
        placeholder="بر اساس ..."
        value={sort}
        onChange={sortHandler}
        options={sortOptions}
      />
    </div>
  );
};

export default Filter;
